import ProductVideo from "./ProductVideo";
import { products } from "@/mocks/products";

const previews = products.slice(0, 3);

export default function FreeTrial() {
  return (
    <section id="teste-gratis" className="bg-background-100 py-24 md:py-32">
      <div className="mx-auto max-w-5xl px-4 md:px-6">
        <div className="reveal mx-auto max-w-3xl text-center">
          <span className="mb-5 inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.2em] text-primary-600">
            <span className="h-px w-6 bg-current" />
            Teste grátis
            <span className="h-px w-6 bg-current" />
          </span>
          <h2 className="font-heading text-3xl font-bold leading-[1.08] tracking-tight text-foreground-950 md:text-5xl">
            Ainda não sabe como seus pratos{" "}
            <span className="text-primary-500">ficariam no Play Menu?</span>
          </h2>
          <p className="mx-auto mt-6 max-w-xl text-base leading-relaxed text-foreground-600 md:text-lg">
            Teste com seus próprios produtos. Cadastre-se, envie suas fotos e
            solicite até{" "}
            <strong className="font-semibold text-foreground-950">
              3 vídeos gratuitos
            </strong>{" "}
            para ver o resultado antes de decidir.
          </p>
        </div>

        {/* Prévia dos 3 vídeos */}
        <div className="mt-14 grid grid-cols-1 gap-5 sm:grid-cols-3 md:mt-16">
          {previews.map((p, i) => (
            <div
              key={p.id}
              className="reveal relative overflow-hidden rounded-2xl border border-background-200 bg-foreground-950"
              style={{ transitionDelay: `${i * 90}ms` }}
            >
              <div className="aspect-[3/4]">
                <ProductVideo src={p.video} poster={p.image} alt={p.name} />
              </div>
              <span className="absolute left-4 top-4 rounded-full bg-foreground-950/80 px-3 py-1 text-[10px] font-bold uppercase tracking-widest text-foreground-100 backdrop-blur">
                Vídeo {String(i + 1).padStart(2, "0")}
              </span>
            </div>
          ))}
        </div>

        <div className="reveal mt-12 flex flex-col items-center gap-4">
          <a
            href="https://playmenu.app/cadastro?tipo=restaurante"
            target="_blank"
            rel="noopener"
            className="inline-flex items-center justify-center whitespace-nowrap rounded-full bg-primary-500 px-9 py-4 text-base font-semibold text-foreground-950 transition-all hover:bg-primary-400 hover:scale-[1.02]"
          >
            Criar meus 3 vídeos grátis
            <i className="ri-arrow-right-line ml-2 text-lg" aria-hidden="true" />
          </a>
          <p className="text-sm text-foreground-500">
            Sem pagamento. Sem compromisso. Apenas veja seus produtos ganharem vida.
          </p>
        </div>
      </div>
    </section>
  );
}